<template>
	<div class="site-wrapper" :class="{ 'loading-blur': loading }">
		<div class="site-content">

			<div class="page">
				<div class="page__header">
					<div class="page__container">
						<h1 class="page__title" v-if="pages.length > 0" v-html="pages[0].label"></h1>
					</div>
				</div><!-- /.page__header -->
				<div class="page__content">

					<div class="page__container">
						<div class="block" v-for="page in pages" :key="'page_article--'+page.id">
							<div class="block__content block--minimal content-page__content" v-html="page.content">

							</div>
						</div>
					</div>
				</div><!-- /.page__content -->
				<div class="footerContent" v-if="isDownloadBrochure">
					<div class="container">
						<div class="row">
							<div class="col-12 col-lg-5 d-flex justify-content-center" v-html="t('content.page.brochureLink')">

							</div>
							<div class="col-12 col-lg-7 d-flex justify-content-center textFooter" v-html="t('content.page.brochuretext')">

							</div>

						</div>
					</div>
				</div>
			</div><!-- /.page -->

		</div>
	</div>
</template>
<script>


	import Vuex from 'vuex';
	import {instance} from '@/api';
	import {contentPageApi} from '@/api';

	export default {
		name: 'ContentPage',
		data() {
			return {
				loading: true,
				title: '',
				content: '',
				pages: []
			}
		},
		beforeRouteEnter(to, from, next) {

			//app.$store.commit('addLoad', 'getContent');
			instance.get(contentPageApi.page + to.params.pageName)
				.then((responce) => {

					if (responce.data && responce.data.status === 'SUCCESS') {
						next(vm => vm.setData(responce.data));
					} else {
						console.warn('Network error or no such page.');
						this.$router.push({name: '404'})
					}


				}).catch(function () {
					this.$router.push({name: '404'})
				})
				.then(() => {
					//app.$store.commit('endLoad', 'getContent');
				});

		},
		beforeRouteUpdate(to, from, next) {
			this.loading = true;
			this.title = '';
			this.content = '';
			//app.$store.commit('addLoad', 'getContent');
			instance.get(contentPageApi.page + to.params.pageName)
				.then((responce) => {
					if (responce.data && responce.data.status === 'SUCCESS') {
						this.setData(responce.data);
						next();
					}else{
						this.$router.push({name: '404'})
					}


				}).catch(function () {
					this.$router.push({name: '404'})
				})
				.then(() => {
					//app.$store.commit('endLoad', 'getContent');
				});

		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),

			isDownloadBrochure(){
				return this.$route.params.pageName && this.$route.params.pageName === 'responsible';
			}
		},
		mounted() {

		},
		methods: {
			setData(data) {


				if(data.content.length > 0){

					this.pages = data.content;



					document.title = 'LNL - ' +  data.content[0].label;
				}

				this.loading = false;


			}
		}
	}
</script>
<style lang="scss" src="@/scss/plugins/_responcible-page.scss">

</style>